import { PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const AIRevisionPluginKey = new PluginKey<State>('AIRevision')
